module.exports = __webpack_public_path__ + "img/man.262e4c5b.png";